




















import { Vue, Component, Watch } from "vue-property-decorator";
import TemplatesModule from "@/store/modules/templates";
import TemplateCard from "@/components/TemplateCard.vue";
import Template from "@/models/template";
import TemplateSelection from "@/models/templateSelection";

@Component({
  components: {
    TemplateCard
  }
})
export default class TemplatesList extends Vue {
  private get templates(): Template[] {
    return TemplatesModule.templates.valueOr([]);
  }

  private get loading(): boolean {
    return TemplatesModule.templates.loading;
  }

  private get error(): any {
    return TemplatesModule.templates.error;
  }

  @Watch("loading")
  private onLoadingChanged(loading: boolean) {
    this.$emit("loading-changed", this.$t("loadingDescription"), loading);
  }

  private created() {
    TemplatesModule.updateTemplates();
  }

  private retry() {
    TemplatesModule.updateTemplates();
  }

  private onTemplateSelected(templateSelection: TemplateSelection) {
    TemplatesModule.setSelectedTemplate(templateSelection);
  }
}
